import { useTranslation } from 'react-i18next';

export default function WhatWeDo() {
  const { t } = useTranslation('home');

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4 sm:mb-6 px-4">
            {t('whatWeDo.title')}
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-3xl mx-auto px-4">
            {t('whatWeDo.description')}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          <div className="bg-slate-50 p-6 sm:p-8 rounded-lg">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-teal-600 rounded-lg flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-phone-line text-white text-xl sm:text-2xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-3 sm:mb-4">
              {t('whatWeDo.realPhone.title')}
            </h3>
            <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
              {t('whatWeDo.realPhone.description')}
            </p>
          </div>

          <div className="bg-slate-50 p-6 sm:p-8 rounded-lg">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-teal-600 rounded-lg flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-building-line text-white text-xl sm:text-2xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-3 sm:mb-4">
              {t('whatWeDo.activeCompanies.title')}
            </h3>
            <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
              {t('whatWeDo.activeCompanies.description')}
            </p>
          </div>

          <div className="bg-slate-50 p-6 sm:p-8 rounded-lg sm:col-span-2 md:col-span-1">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-teal-600 rounded-lg flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-file-excel-line text-white text-xl sm:text-2xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-3 sm:mb-4">
              {t('whatWeDo.readyToUse.title')}
            </h3>
            <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
              {t('whatWeDo.readyToUse.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
